<app-layout-page>
  <app-layout-header></app-layout-header>
  <app-layout-content class="content">
    <h3 trans="shared.notFound.title"></h3>
    <p trans="shared.notFound.p1"></p>
  </app-layout-content>
</app-layout-page>
